import React from 'react';
import Helmet from 'react-helmet';
import { withIntl, propTypes as intlPropTypes } from 'ha/i18n';

const Organization = ({ intl: { urlResolver } }) => (
  <Helmet>
    <script type="application/ld+json">
      {`{
          "@context": "http://schema.org",
          "@type": "Organization",
          "name": "HousingAnywhere.com",
          "legalName": "Housing Anywhere B.V.",
          "url": "${urlResolver.absolutizePath(`/`)}",
          "logo": "${urlResolver.getBaseUrl()}/img/logo-full-2x.png",
          "foundingDate": "2009",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Hofplein 20",
            "addressLocality": "Rotterdam",
            "postalCode": "3032AC",
            "addressCountry": "NLD"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "telephone": "[+31 85 888 1399]",
            "email": "support@housinganywhere.com"
          },
          "sameAs": [
            "https://www.facebook.com/HousingAnywherecom",
            "https://twitter.com/HousingAnywhere",
            "https://www.youtube.com/user/HousingAnywhere",
            "https://www.linkedin.com/company/housinganywhere-com"
          ]
        }
      `}
    </script>
  </Helmet>
);

Organization.propTypes = {
  intl: intlPropTypes.isRequired,
};

export default withIntl(Organization);
